import {Button} from '@startlibs/components'
import { getColor } from '@startlibs/utils';
import {usePopupToggle} from '@startlibs/core'
import React, {useEffect} from 'react'
import styled from 'styled-components';

import {FileInput} from '../AddStudiesButton'

export const FileInputBoxStyle = styled.div`
  height: 9rem;
  border-radius: 5px;
  border: 1px dashed ${getColor('gray180')};
  background: ${getColor('gray240')};
  position: relative;
  padding: 1rem 1rem 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: rgba(0,0,0,0.6);
  user-select: none;
  font-size: 13px;
  ${Button} {
    margin-bottom: 0.75rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
`

export const UploadButtonBox = ({fileEventHandler}) => {
  const directoryInputRef = usePopupToggle()

  useEffect(() => {
    if (!directoryInputRef.current) return
    directoryInputRef.current.setAttribute('webkitdirectory', 'true')
    directoryInputRef.current.setAttribute('directory', 'true')
    directoryInputRef.current.setAttribute('mozdirectory', 'true')
  },[])


  return <FileInputBoxStyle>
    <div>
      <div>
        <Button icon="files" small heighlight>Upload from files<FileInput onChange={fileEventHandler} multiple/></Button>
        <Button icon="directories" small highlight>Upload from folders or disks<FileInput ref={directoryInputRef} onChange={fileEventHandler}/></Button>
      </div>
      <div>Or drag and drop them on this page</div>
    </div>
  </FileInputBoxStyle>
}
